import Vue from 'vue';

// Validation
import { ValidationProvider, ValidationObserver } from 'vee-validate';


// Validaiton
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
